export default {
  articlesData: [],
};
